
import { useState, Fragment } from "react";
import { Tooltip, Chip, } from "@mui/material";
import { createFilterOptions } from '@mui/material/Autocomplete';

//Components
import Autocomplete from '../inputs/Autocomplete';

//Hooks
import useCategories from '../../hooks/category/useCategories';


const ProductCategoryAutocomplete = ({ onChange }) => {
    const [selectedCategories, setSelectedCategories] = useState([]);
    const { categories, loading, findChildren, GetPath, ChangeTextFilter } = useCategories();

    const handleCategoryAutocompleteChange = async (event, options, action, arg) => {
        if (action === "select-option")
            arg.option.children = await findChildren(arg.option);

        setSelectedCategories(options.map(s => s));
        onChange(buildCategoryIds(options));
    }

    let timerId;
    const handleCategoryAutocompleteInputChange = (event, value) => {
        if (event?._reactName !== 'onClick' || value === "") {
            clearTimeout(timerId);
            timerId = setTimeout(() => ChangeTextFilter(value), 500);
        }
    }

    const buildCategoryIds = (categories) => {
        const hash = {};
        categories.forEach(i => {
            hash[i.id] = i.id;
        });

        return Object.keys(hash).map(Number);
    }

    return (
        <>
            <Autocomplete
                fullWidth
                multiple
                loadingText='Buscando categorias...'
                loading={loading}
                options={categories}
                sx={{ paddingTop: '5px' }}
                value={selectedCategories}
                getOptionLabel={(option) => option.description}
                onChange={handleCategoryAutocompleteChange}
                onInputChange={handleCategoryAutocompleteInputChange}
                TextProps={{
                    label: 'Categoría',
                    placeholder: 'Ej.: Dormitorio',
                }}
                filterOptions={createFilterOptions({
                    stringify: (option) => option.description + option.path,
                })}
                renderOption={(props, option) => (
                    <li {...props}>
                        <span>{option.path}</span>
                    </li>)}
                renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                        <Tooltip key={index} title={GetPath(option)}>
                            <Chip label={option.description} {...getTagProps({ index })} />
                        </Tooltip>
                    ))
                }
            />
        </>
    )
}

export default ProductCategoryAutocomplete;